import styled from '@emotion/styled'

export const SkeletonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`
